import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import styles from './style.module.scss'
import { formatDate } from '../../shared/datetime'

/**
 * Erinnerungsstand einer Betreuungsanfrage.
 *
 * Fragt eine Junior Company eine Expert:in an und bleibt die Antwort aus,
 * erinnert das System — bewusst nicht die Schüler:innen. Damit daraus kein
 * stilles Warten wird, zeigen alle Sichten denselben Stand: wie oft erinnert
 * wurde, wann zuletzt, und ob die Anfrage am Ende automatisch abgelehnt wurde.
 *
 * Bewusst ein gemeinsamer Baustein: Schüler:innen-, Lehrkraft- und Admin-Sicht
 * sollen hier nicht auseinanderlaufen.
 */
export default function ReminderNote({
	status,
	reminderCount,
	lastReminderAt,
	autoDeclined,
	audience = 'requester'
}) {
	const { t } = useTranslation()

	if (autoDeclined) {
		return <p className={styles.expired}>{t('autoDeclinedHint')}</p>
	}

	if (status !== 'REQUESTED') return null

	if (!reminderCount) {
		// Der Hinweis „das System erinnert" richtet sich an die anfragende Seite.
		// Der angefragten Person waere damit nicht geholfen - sie soll antworten,
		// nicht auf eine Erinnerung warten.
		return audience === 'requester' ? <p className={styles.note}>{t('systemRemindsHint')}</p> : null
	}

	return (
		<p className={styles.note}>
			{t('systemReminded', { count: reminderCount })}
			{lastReminderAt ? ` — ${t('lastReminder', { date: formatDate(lastReminderAt) })}` : ''}
		</p>
	)
}

ReminderNote.propTypes = {
	status: PropTypes.string,
	reminderCount: PropTypes.number,
	lastReminderAt: PropTypes.string,
	autoDeclined: PropTypes.bool,
	audience: PropTypes.oneOf(['requester', 'recipient'])
}
